import React from 'react';
import type { CustomCellRendererProps } from 'ag-grid-react';
import Chip, { type ChipProps } from '@mui/material/Chip';

type ColorStringValue = {
  value: string;
  color: ChipProps['color'];
};

/**
 * Renders a status/label cell as an MUI Chip. The chip sizes to its label so the
 * colored background matches the status text length rather than stretching to the
 * full column width when the column is resized (DPM-570).
 */
const ColorStringCellRenderer: React.FC<CustomCellRendererProps<unknown, ColorStringValue>> = ({ value }) => {
  const { value: label, color } = value ?? {};

  if (!label) {
    return null;
  }

  return <Chip label={label} size="small" color={color} />;
};

export default ColorStringCellRenderer;
